var _defs, _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _rect3, _rect4, _path9, _path10, _rect5, _path11, _path12, _path13, _rect6, _path14, _rect7, _rect8, _path15, _path16, _path17, _path18, _path19, _path20, _rect9, _path21, _rect10, _rect11, _rect12, _path22, _path23, _path24, _path25, _rect13, _path26, _path27, _path28, _rect14, _path29, _path30, _path31, _rect15, _path32, _path33, _path34, _path35, _rect16, _path36, _rect17, _path37, _path38, _rect18, _path39, _path40, _rect19, _path41, _path42, _path43, _path44, _rect20, _path45, _path46, _rect21, _rect22, _path47, _rect23, _rect24, _rect25, _path48, _path49, _path50, _path51, _path52, _rect26, _rect27, _path53, _path54, _rect28, _path55, _rect29, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _rect30, _path66, _rect31, _rect32, _path67, _path68, _rect33, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _rect34, _rect35, _path79, _path80, _rect36, _path81, _rect37, _rect38, _path82, _path83, _path84, _rect39, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _rect40, _rect41, _path94, _path95, _path96, _rect42, _rect43, _rect44, _rect45, _rect46, _path97, _path98, _path99, _path100, _rect47, _path101, _path102, _path103, _rect48, _path104, _path105, _path106, _rect49, _rect50, _path107, _path108, _path109, _rect51, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _rect52, _path117, _rect53, _path118, _rect54, _path119, _rect55, _rect56, _path120, _path121, _rect57, _path122, _path123, _path124, _path125, _path126, _rect58, _rect59, _rect60, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 2000 2000",
    x: 0,
    y: 0,
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 2000,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 223,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 223,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 223,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 223,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 297,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 297,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 297,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 297,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 371,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 371,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 371,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 445,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 445,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 445,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 519,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 519,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 519,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 593,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 593,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 593,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 667,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 667,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 667,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 667,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 667,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 667,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 667,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 667,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 741,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 741,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 741,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 741,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 741,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 223,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 297,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 371,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 445,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 667,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 741,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1555,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 815,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 223,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 297,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 371,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 519,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 667,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 667,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 741,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1481,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 889,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 297,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 371,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 667,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 741,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1185,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1481,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1555,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 963,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 297,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 371,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 445,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 519,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 593,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 667,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 667,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 741,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1481,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1037,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 297,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 371,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 445,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 519,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 593,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 667,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1185,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1111,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1185,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 1185,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 1185,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 1185,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1185,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1481,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1555,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1555,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1259,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1185,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1481,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1555,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1333,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1185,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1481,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1555,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1407,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1481,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 1481,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 1481,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 1481,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1481,
    y: 1481,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1555,
    y: 1481,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1481,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0.85A0.85,0.85,0,0,0,0,0.85V4H4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1555,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1555,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 1555,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 1555,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 1555,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4,
    rx: 0.85
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 1555,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,4A0.85,0.85,0,0,0,4,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1555,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1185,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0H0.85A0.85,0.85,0,0,0,0,0.85v2.3A0.85,0.85,0,0,0,0.85,4H4V0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.15,0A0.85,0.85,0,0,1,4,0.85V4H0V0H3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4A0.85,0.85,0,0,1,0,3.15V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0A0.85,0.85,0,0,0,0,0.85V4H4V0H0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1629,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,3.15A0.85,0.85,0,0,1,3.15,4H0V0H4V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 815,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 889,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 963,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1037,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1111,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1259,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4,0.85V0H3.15A0.85,0.85,0,0,1,4,0.85Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1333,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4H4V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1407,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0.85A0.85,0.85,0,0,0,3.15,0H0V4Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1629,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,3.15A0.85,0.85,0,0,0,0.85,4h2.3A0.85,0.85,0,0,0,4,3.15V0H0V3.15Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4 4",
    x: 1703,
    y: 1703,
    width: 74,
    height: 74,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0.85,0H0V0.85A0.85,0.85,0,0,1,0.85,0Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 223,
    y: 223,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 518,
    height: 518,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 223,
    y: 223,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 518,
    height: 518,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1259,
    y: 223,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 518,
    height: 518,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 1259,
    y: 223,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 518,
    height: 518,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 223,
    y: 1259,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 518,
    height: 518,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M21.2-0.1C9.5-0.1-0.1,9.5-0.1,21.2v78.8v100v100v100v100v100v78.8c0,11.7,9.5,21.3,21.3,21.3h657.6  c11.7,0,21.3-9.5,21.3-21.3V600V500V400V300V200v-100V21.2c0-11.7-9.5-21.3-21.3-21.3H21.2z M600,200v100v100v100v87.8  c0,6.8-5.5,12.2-12.2,12.2H112.2c-6.8,0-12.2-5.5-12.2-12.2V500V400V300V200v-87.8c0-6.8,5.5-12.2,12.2-12.2h475.6  c6.8,0,12.2,5.5,12.2,12.2V200z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 223,
    y: 1259,
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    width: 518,
    height: 518,
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M500,400V300v-78.8c0-11.7-9.5-21.3-21.3-21.3H221.2c-11.7,0-21.3,9.5-21.3,21.3V300v100v78.8    c0,11.7,9.5,21.3,21.3,21.3h257.5c11.7,0,21.3-9.5,21.3-21.3V400z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.788f6221bcaba7499453f6435c59ee13.svg";
export { ForwardRef as ReactComponent };